import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { Logo } from "@/components/Navbar";
import {
  GridFour, Users, ChatCircle, ListNumbers, Article, Gear, Calendar,
} from "@phosphor-icons/react";

const ITEMS = [
  { to: "/admin", end: true, label: "Dashboard", icon: GridFour },
  { to: "/admin/signups", label: "Signups", icon: Users },
  { to: "/admin/leads", label: "Leads", icon: ChatCircle },
  { to: "/admin/waitlist", label: "Waitlist", icon: ListNumbers },
  { to: "/admin/blogs", label: "Journal", icon: Article },
  { to: "/admin/settings", label: "Settings", icon: Gear },
  { to: "/admin/exports", label: "Exports", icon: Calendar },
];

export default function AdminLayout() {
  return (
    <div className="min-h-screen bg-paper">
      <div className="grid lg:grid-cols-[260px_1fr] min-h-screen">
        <aside className="bg-white border-r border-rule px-6 py-8 hidden lg:block">
          <Logo />
          <div className="mt-3 label-mono">Admin · Control room</div>
          <nav className="mt-10 space-y-px">
            {ITEMS.map((it) => (
              <NavLink key={it.to} to={it.to} end={it.end}
                data-testid={`admin-nav-${it.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2.5 text-sm font-medium border-l-2 transition-colors ${
                    isActive
                      ? "bg-surface-hover border-ink text-ink"
                      : "border-transparent text-ink/60 hover:bg-surface-hover hover:text-ink"
                  }`
                }>
                <it.icon weight="duotone" className="w-4 h-4" /> {it.label}
              </NavLink>
            ))}
          </nav>
        </aside>
        <main className="p-6 lg:p-12 max-w-[1400px]"><Outlet /></main>
      </div>
    </div>
  );
}
